module.exports = __webpack_public_path__ + "img/splash.00eb0c50.png";